import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { AuthenticationService } from '../../service/authentication.service';
import { Observable } from 'rxjs/Observable';
import { TokenKey } from '../../service/tokenKey';
import { HttpConst, TimeOut_UnitOfTime } from './http.const';
import * as moment from 'moment';
import 'rxjs/add/operator/mergeMap';
import {Router} from '@angular/router';
import { TokenBanTotalResponse } from '../../../seguridad/models/main/response/tokenBanTotalResponse.model';

@Injectable()
export class HttpBaseInterceptor implements HttpInterceptor {
  constructor(
    public auth: AuthenticationService, 
    private inj: Injector,
     private router: Router
     ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
    ): Observable<HttpEvent<any>> {    
    //let timeout = ;
    HttpConst.TIMEOUT_UNIT_OF_TIME = TimeOut_UnitOfTime.MINUTES;
    let token = this.getToken();
    if(token!=null){
      let accessToken = token.accessToken;
      const expiresOnDate = moment(token.expiresOn);
      const current = moment();

/*
      console.log('expiresOnDate : ' + expiresOnDate.format());
      console.log('current : ' + current.format());
      console.log('current.isSameOrBefore(expiresOnDate) : ' + current.isSameOrBefore(expiresOnDate));
      console.log('HttpConst.TIMEOUT_UNIT_OF_TIME : ' + HttpConst.TIMEOUT_UNIT_OF_TIME);
      console.log('HttpConst.TIMEOUT : ' + HttpConst.TIMEOUT);
      console.log('current.diff( expiresOnDate, HttpConst.TIMEOUT_UNIT_OF_TIME) : ' + current.diff( expiresOnDate, HttpConst.TIMEOUT_UNIT_OF_TIME));
      console.log('current.diff( expiresOnDate, HttpConst.TIMEOUT_UNIT_OF_TIME) <= HttpConst.TIMEOUT : ' + (current.diff( expiresOnDate, HttpConst.TIMEOUT_UNIT_OF_TIME)  <= HttpConst.TIMEOUT));
      console.log('primera condicion: ' + !current.isSameOrBefore(expiresOnDate));
      console.log('segunda condicion: ' + (current.diff( expiresOnDate, HttpConst.TIMEOUT_UNIT_OF_TIME) <= HttpConst.TIMEOUT));
*/
      if(
        !(
          current.diff( expiresOnDate, HttpConst.TIMEOUT_UNIT_OF_TIME) <=
           HttpConst.TIMEOUT
           )
        ) {
        localStorage.clear();
        $('#modalSesionExpirada').show();
        return Observable.throw('volver a iniciar sesión');
      }

      if (!current.isSameOrBefore(expiresOnDate) && 
         current.diff( expiresOnDate, HttpConst.TIMEOUT_UNIT_OF_TIME) <=
          HttpConst.TIMEOUT
          ) {
        // console.log('a refrescar token'); // ADD EXP(GVASQUEZ) 20241001 - REQ37988 : Comentar console.log
        const refreshTokenReq: Observable<HttpEvent<any>> = this.auth
        .refreshToken()
        .mergeMap((response: boolean) => {
          if (response) {
            token = this.getToken();
            if(token!=null){
              const authReq = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${this.getToken().accessToken}`
                }
              });
    
              return next.handle(authTokenReq).do(this._next, this._error);
            }else{
              this.router.navigate(['./']);
            }
          } else {
            return Observable.throw('refresh token');
          }
        }); 
        return refreshTokenReq;
      }

      //INICIO EXP(AVR) 20230712
      let BanTotalToken = this.getBanTotalToken();
      let authTokenReq: any;


      if (BanTotalToken != null) {
        authTokenReq = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.getToken().accessToken}`,
            BanTotalAuthorization: `${this.getBanTotalToken().dispositivo}/${
              this.getBanTotalToken().token
            }`,
          },
        });
      } else {
        authTokenReq = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.getToken().accessToken}`,
          },
        });
      }

      //FIN EXP(AVR) 20230712
      
      return next.handle(authTokenReq);
    }else{
      return next.handle(request);
    }
 }

  private _next(event: HttpEvent<any>) {
    if (event instanceof HttpResponse) {
      // do stuff with response if you want
    }
  }

  private _error(err: any) {
    if (err instanceof HttpErrorResponse) {
      if (err.status === 401) {
        //this.router.navigate(['./']);
        return err;
      }
    }
  }

  private getToken(): TokenKey {
    return JSON.parse(localStorage.getItem(HttpConst.LOCAL_STORAGE_KEY_TOKEN));
  }
  

  //INICIO EXP(AVR) 20230712 OBTENCION DEL TOQUEN
  private getBanTotalToken(): TokenBanTotalResponse {
    return JSON.parse(localStorage.getItem("objBanTotalCredentials"));
  }
  //FIN EXP(AVR) 20230712 OBTENCION DEL TOQUEN
}